import copy from 'copy-to-clipboard';
import React, { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';

import { DOC_BASE_URL } from '../../../../../util/constant';
import { IDocumentId } from '../../Document.props';
import useEditDocument from './useEditDocument';

const EditDocument: React.FC<IDocumentId> = ({ documentId, setMethod }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { documentData, handleInputChange, handleFileChange, handleSave } =
    useEditDocument(documentId, setMethod);

  // Update URL when document is loaded
  useEffect(() => {
    if (documentData?.link) {
      setSearchParams({ doc: documentData.link });
    }
  }, [documentData]);

  const handleShare = () => {
    const currentUrl =
      "https://task.blisslers.com/document?doc=" + documentData?.link;
    console.log("Sharing URL:", currentUrl);
    copy(currentUrl);
    toast.success("Link copied to clipboard!", { duration: 3000 });
  };

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6">
      <div className="bg-white w-full shadow-md rounded-md p-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold">Document Editor</h1>
          {documentData?.title && (
            <button
              onClick={handleShare}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Share Document
            </button>
          )}
        </div>
        <form className="space-y-6 p-6 h-[75vh] overflow-y-scroll">
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Title
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData?.title}
              onChange={(e) => handleInputChange("title", e.target.value)}
              placeholder="Enter document title"
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Tag</label>
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData?.tag}
              onChange={(e) => handleInputChange("tag", e.target.value)}
              placeholder="Enter document title"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Link</label>
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData?.link}
              onChange={(e) => handleInputChange("link", e.target.value)}
              placeholder="Enter document title"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Video Link
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData?.video}
              onChange={(e) => handleInputChange("video", e.target.value)}
              placeholder="Enter document title"
            />
          </div>
          <div>
            {documentData?.video && (
              <div>
                <video className="w-100 h-100" controls>
                  <source src={documentData?.video} />
                </video>
              </div>
            )}
            <iframe
              src={`${DOC_BASE_URL}${documentData?.link}`}
              width="100%"
              height="600"
              title="Document Viewer"
              frameBorder="0"
            />
          </div>
          <button
            type="button"
            onClick={handleSave}
            className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          >
            Save Document
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditDocument;
